import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "engagement-report" };
import EngagementReportHeader from '@/features/EngagementReport/components/EngagementReportHeader/Header.vue';
import EngagementReportTable from '@/features/EngagementReport/components/EngagementReportTable/Table.vue';
import ModalProcessProgress from '@/features/EngagementReport/components/Modals/ModalProcessProgress.vue';
import ModalExportSuccess from '@/features/EngagementReport/components/Modals/ModalExportSuccess.vue';
import ModalExportError from '@/features/EngagementReport/components/Modals/ModalExportError.vue';
import EngagementReportKpis from '@/features/EngagementReport/components/EngagementReportKpis/Kpis.vue';
import EngagementReportGraphic from '@/features/EngagementReport/components/EngagementReportGraphic/Graphic.vue';
// libs
import { onMounted } from 'vue';
// utils
import { useMixpanelConfig } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EngagementReport',
    setup(__props) {
        // components
        onMounted(() => {
            useMixpanelConfig('view_oto_engagement_report');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createVNode(EngagementReportHeader),
                _createVNode(EngagementReportKpis),
                _createVNode(EngagementReportGraphic),
                _createVNode(EngagementReportTable),
                _createVNode(ModalProcessProgress),
                _createVNode(ModalExportSuccess),
                _createVNode(ModalExportError)
            ]));
        };
    }
});
